const Checkout = () => {
  return <h2>Order placed successfully 🎉</h2>;
};

export default Checkout;